module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Banner', {
    attrs: {
      "xinfo": _vm.info
    }
  }), _vm._v(" "), _c('List', {
    attrs: {
      "xsongs": _vm.songs
    }
  }), _vm._v(" "), _c('xplay')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b37113c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rangeDetails.vue
// module id = 272
// module chunks = 0